import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const checkedInputDefaultVariants = {}
const checkedInputCompoundVariants = []

const checkedInputSlotNames = [
  [
    "control",
    "selection-control__control"
  ],
  [
    "input",
    "selection-control__input"
  ],
  [
    "action_wrapper",
    "selection-control__action_wrapper"
  ],
  [
    "checkbox",
    "selection-control__checkbox"
  ],
  [
    "radio",
    "selection-control__radio"
  ],
  [
    "label",
    "selection-control__label"
  ]
]
const checkedInputSlotFns = /* @__PURE__ */ checkedInputSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, checkedInputDefaultVariants, getSlotCompoundVariant(checkedInputCompoundVariants, slotName))])

const checkedInputFn = memo((props = {}) => {
  return Object.fromEntries(checkedInputSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const checkedInputVariantKeys = []
const getVariantProps = (variants) => ({ ...checkedInputDefaultVariants, ...compact(variants) })

export const checkedInput = /* @__PURE__ */ Object.assign(checkedInputFn, {
  __recipe__: false,
  __name__: 'checkedInput',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: checkedInputVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, checkedInputVariantKeys)
  },
  getVariantProps
})